// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dghOuterDIV {
  margin: 11px 0px 4px 0px;
}

  .dghOuterDIV > span {
    margin-right: 5px;
  }

  .dghOuterDIV > .dghLine {
    height: 1px;
    background: silver;
    align-self: center;
  }
`, "",{"version":3,"sources":["webpack://./src/app/components/common/default.group.header.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;AAC1B;;EAEE;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,kBAAkB;EACpB","sourcesContent":[".dghOuterDIV {\n  margin: 11px 0px 4px 0px;\n}\n\n  .dghOuterDIV > span {\n    margin-right: 5px;\n  }\n\n  .dghOuterDIV > .dghLine {\n    height: 1px;\n    background: silver;\n    align-self: center;\n  }\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
